/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { Theme, LoadingErrorState } from "../types"
import ErrorIcon from "@material-ui/icons/ErrorOutlineRounded"
import { Fragment } from "react"
import { CircularProgress } from "@material-ui/core"

type Props = {
    state: LoadingErrorState
    errorText: string
    retyingText: string
}

function ErrorState(props: Props) {
    return (
        <div css={styles.container}>
            {(props.state === "error" && (
                <Fragment>
                    <ErrorIcon css={styles.errorIcon} fontSize="large" />
                    <span css={styles.errorText}>{props.errorText}</span>
                </Fragment>
            )) ||
                (props.state === "retrying" && (
                    <Fragment>
                        <CircularProgress css={styles.warningText} />
                        <span css={styles.warningText}>
                            {props.retyingText}
                            <br />
                            {
                                "Maradj az oldalon, amég a rendszer próbál helyreállni!"
                            }
                        </span>
                    </Fragment>
                )) ||
                null}
        </div>
    )
}
export default ErrorState

const styles = {
    container: (theme: Theme) => css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        & span {
            text-align: center;
        }
    `,
    errorIcon: (theme: Theme) => css`
        font-size: ${theme.fontSizes.xxLarge};
        color: ${theme.palette.error.main};
    `,
    errorText: (theme: Theme) => css`
        color: ${theme.palette.error.main};
    `,
    warningText: (theme: Theme) => css`
        color: ${theme.palette.warning.main};
    `,
}
